import { useFeedbackDialogContext } from '@frameio/shared/contexts/ModalContext/ModalContext';
import { InlineButton, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/SubmitFeedback';
import styles from './SubmitFeedback.module.css';

TEXT.DEFINE({
  /** Prompt text asking if user has a suggestion */
  haveSuggestion: 'Have a suggestion?',
  /** Button text to submit feedback */
  submitFeedback: 'Submit feedback',
});

export const SubmitFeedback = () => {
  const { openFeedbackDialog } = useFeedbackDialogContext();
  const handleOpenFeedbackDialog = () => openFeedbackDialog('searchFeedback');

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.feedbackWrapper}>
        <Text color="tertiary" variant="linkSmall">
          {TEXT.haveSuggestion}
        </Text>
        <InlineButton onPress={handleOpenFeedbackDialog}>
          <Text color="body" variant="linkSmall">
            {TEXT.submitFeedback}
          </Text>
        </InlineButton>
      </div>
    </div>
  );
};
